export const upcomingEventsData = [
    {
        id: 1,
        schedule_name: "Meeting for campaign with sales team",
        date: {
            day: "20",
            month: "Dec",
            time: "11:30am - 12:30pm"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Mikal Bon",
                user_img: "/images/avatar/3.png"
            },
            {
                id: 3,
                user_name: "Socrates Itumay",
                user_img: "/images/avatar/4.png"
            },
            {
                id: 4,
                user_name: "Jakson Jak",
                user_img: "/images/avatar/6.png"
            },
            {
                id: 5,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            }
        ]
    },
    {
        id: 2,
        schedule_name: "Meeting for campaign with sales team",
        date: {
            day: "21",
            month: "Dec",
            time: "10:00am - 12:00pm"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Mikal Bon",
                user_img: "/images/avatar/3.png"
            },
            {
                id: 3,
                user_name: "Marianne Audrey",
                user_img: "/images/avatar/5.png"
            },
            {
                id: 4,
                user_name: "Jakson Jak",
                user_img: "/images/avatar/6.png"
            },
            {
                id: 5,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            }
        ]
    },
    {
        id: 3,
        schedule_name: "Meeting for campaign with sales team",
        date: {
            day: "22",
            month: "Dec",
            time: "8:00am - 9:00am"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Mikal Bon",
                user_img: "/images/avatar/3.png"
            },
            {
                id: 3,
                user_name: "Socrates Itumay",
                user_img: "/images/avatar/4.png"
            },
            {
                id: 4,
                user_name: "Marianne Audrey",
                user_img: "/images/avatar/5.png"
            },
            {
                id: 5,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            }
        ]
    },
    {
        id: 4,
        schedule_name: "Meeting for campaign with sales team",
        date: {
            day: "23",
            month: "Dec",
            time: "10:00am - 11:00am"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Mikal Bon",
                user_img: "/images/avatar/3.png"
            },
            {
                id: 3,
                user_name: "Socrates Itumay",
                user_img: "/images/avatar/4.png"
            },
            {
                id: 4,
                user_name: "Marianne Audrey",
                user_img: "/images/avatar/5.png"
            },
            {
                id: 5,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            }
        ]
    },
    {
        id: 5,
        schedule_name: "Meeting for campaign with sales team",
        date: {
            day: "24",
            month: "Dec",
            time: "10:00am - 11:00am"
        },
        team_members: [
            {
                id: 1,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            },
            {
                id: 2,
                user_name: "Mikal Bon",
                user_img: "/images/avatar/3.png"
            },
            {
                id: 3,
                user_name: "Socrates Itumay",
                user_img: "/images/avatar/4.png"
            },
            {
                id: 4,
                user_name: "Marianne Audrey",
                user_img: "/images/avatar/5.png"
            },
            {
                id: 5,
                user_name: "Janette Dalton",
                user_img: "/images/avatar/2.png"
            }
        ]
    }
]